<template>

<div class="grid-content bg-purple">
<h2 style="float: left;">平台评分列表</h2>
<el-tag
  v-for="item in items"
  :key="item.id"
  :type="item.type"
  @click="selecTopera(item.id)"
  :class="{active : item.id===curId}"
  effect="light">
{{ item.label }}
</el-tag>
<div class="table-box">


<el-table
  :data="operator"
  height="550"
  border
  style="width: 100%;">
  <el-table-column
    label="季度"
    width="180">
    <template slot-scope="scope">
      {{scope.row.year}}年第({{scope.row.quarter}})季
    </template>
  </el-table-column>
  <el-table-column
    prop="operatorName"
    label="运营企业"
    width="180">
  </el-table-column>
  <el-table-column
    prop="totalPoints"
    label="季度评分">
  </el-table-column>
  <el-table-column
    prop="grade"
    label="季度评分排名">
  </el-table-column>

  <el-table-column

    label="操作">
    <template slot-scope="scope">
      <el-button
        size="mini"
        type="success"
        @click="openEdit(scope.row.gradeId,3)"
      >查看详情</el-button>
    </template>
  </el-table-column>
</el-table>
<el-pagination
  background
  layout="prev, pager, next"
  :page-size="operatorpageSize"
  @current-change="setselecTopera"
  :total="operatortotal">

</el-pagination>
</div>
  </div>
</template>
<script>
export default {
  name: "Audittraffic",
  data(){
    return {
      items: [
        {   id:1,
          type: 'success',
          code:'MT'
        },
        {   id:2,
          type: 'info',
          code:'HB'
        },
        {
          id:3,
          type: 'danger',
          code:'DD'
        },
      ],
      operatorpage:1,
      operatortotal:0,
      operatorpageSize:10,
      operator:[],
      curId:1,
    }
  },
  beforeRouteEnter(to,from,next){

    next((vm)=>{

    });
  },
  created(){

  },
  mounted () {
    this.selecTopera(1)
  },
  methods: {
    // 获取评分列表
    selecTopera(index){
      let that = this;
      this.curId = index;
      let operators ={
        page:this.operatorpage,
        pageSize:this.operatorpageSize,
        operatorNum:index ,
      }
      this.$axios.defaults.withCredentials=true;
      this.$axios
        .post('/api/grade/selectGradeList',operators)
        .then(function (res) {
          that.operatortotal = res.data.data.total;
          that.operator = res.data.data.list;
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },
    setselecTopera(operatorpage){
      this.operatorpage = operatorpage;
      this.selecTopera(this.curId);
    },
    openEdit(cid,typeid){
      this.$router.push({name:'Ashowscore' , params:{cid:cid ,curId:this.curId, typeid:typeid}})
    },
  },
  watch: {

  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/admin/Audittraffic.vue